export const CLIENT_VIEWS = [
  "overview",
  "events",
  "subscription",
  "gallery",
  "profile",
  "support"
];

export function getClientViewFromUrl(location = globalThis.location) {
  if (!location) return "overview";
  const url = new URL(
    location.href || `${location.pathname || "/"}${location.search || ""}`,
    "http://localhost"
  );
  const view = url.searchParams.get("view");
  if (CLIENT_VIEWS.includes(view)) return view;
  if (url.searchParams.has("session_id")) return "subscription";
  return "overview";
}

export function navigateClientView(
  view,
  history = globalThis.history,
  location = globalThis.location
) {
  if (!CLIENT_VIEWS.includes(view) || !history || !location) return false;
  const url = new URL(location.href, "http://localhost");
  url.searchParams.set("view", view);
  if (view !== "subscription") url.searchParams.delete("session_id");
  history.pushState(
    { ...(history.state || {}), view },
    "",
    `${url.pathname}${url.search}${url.hash}`
  );
  return true;
}
